module.exports = __webpack_public_path__ + "img/Pond_fish_farming.01ba449b.jpg";